import type { IQuickInputPreviewTarget } from "../../quickinput/common/quickInput.js";
import type { IResourceEntry } from "../../resources/common/resources.js";

/** Adapts a weak resource-registry entry without retaining its live resource. */
export function createResourceQuickPickPreviewTarget(entry: IResourceEntry): IQuickInputPreviewTarget {
    return {
        key: `resource:${entry.kind}:${entry.id}`,
        label: entry.name || entry.type,
        deref: () => entry.deref(),
    };
}

/** Weak fallback for objects discovered before the resource tracker registers them. */
export function createWeakQuickPickPreviewTarget(key: string, label: string, target: object): IQuickInputPreviewTarget {
    const reference = new WeakRef(target);
    return {
        key,
        label,
        deref: () => reference.deref(),
    };
}
